import { render, staticRenderFns } from "./selectInstructionAssignments.vue?vue&type=template&id=0bba1056"
import script from "./selectInstructionAssignments.vue?vue&type=script&lang=js"
export * from "./selectInstructionAssignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports